<template>
  <div class="house-container">
    <el-table :data="tableData" border style="width: 100%" class="">
      <el-table-column prop="shopName" label="店铺" align="center"></el-table-column>
      <el-table-column prop="shId" label="仓库编号" align="center"></el-table-column>
      <el-table-column prop="shName" label="仓库名称" align="center"></el-table-column>
      <el-table-column prop="shType" label="仓库类型" align="center">
        <template #default="scope">
          {{ scope.row.shType === '2807' ? '普通仓库' : '总仓库' }}
        </template>
      </el-table-column>
      <el-table-column prop="shDesc" label="描述" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
    </el-table>

    <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
  </div>
</template>

<script>
import { getShopHouseList } from '@/api/shop/shopHouseApi'

export default {
  name: 'AShopDetailHouse',
  props: {
    shopId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
  },
  methods: {
    open(params) {
      this.shopId = params.shopId
      this.loadData()
    },
    async loadData() {
      try {
        const params = {
          shopId: this.shopId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }

        const res = await getShopHouseList(params)
        this.tableData = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('获取仓库列表失败:', error)
      }
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    }
  }
}
</script>

<style scoped>
.house-container {
  padding: 20px;
}

.margin-top {
  margin-top: 20px;
}
</style>